module.exports = __webpack_public_path__ + "static/media/chocolatemilk.69740be5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/chocolatemilk.png
// module id = 107
// module chunks = 0